import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { GET_INCAPACIDADES } from "../../api/Routes";
import ComponentModalErrorSever from "../ComponentModalErrorSever";
import Get from "../../api/Get";

function DoctorIncapacidadColombia({t, citaID, auth, incapacidad, readOnly, pacienteID, showEncuesta}){
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)
    const [historialIncapacidades, setHistorialIncapacidades] = useState([])
    const [open, setOpen] = useState(false)
    const handleCloseModal = () =>setOpen(false)

    useEffect(()=>{
        if(!showEncuesta && showEncuesta !== undefined){
            if(pacienteID!==undefined && pacienteID){
                Get({url: `${GET_INCAPACIDADES}/${pacienteID}`, access_token: auth.data.access_token})
                .then(response=>{
                    if(response.data.data.response.length > 0){
                        //abrir modal
                        let hInca = response.data.data.response.map((item)=>({
                            note: item.note,
                            diagnosticos: item.medicalHistory?.appointment?.diseaseList
                        }))
                        setHistorialIncapacidades(hInca)
                        setOpen(true)
                    }
                })
                .catch(error=>{
                    console.log('error')
                    console.log(error)
                })
            }
        }else{
            setOpen(false)
        }
    }, [])
    return(
        <div className="p-3 pt-4 position-relative">
            <Form.Label className="mt-3">{incapacidad}</Form.Label>
            
            <ComponentModalErrorSever 
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            />
            <Modal show={open} onHide={handleCloseModal} size="lg">
                <Modal.Body className="position-relative overflow-hidden">
                    <h5>Dr el paciente cuenta con un historial de incapacidades</h5>
                    <ul className="list-unstyled">
                        {
                            historialIncapacidades.map((item, i)=>(
                                <li key={i} className="p-2 bg-light mb-2">
                                    <span>{item.note}</span>
                                    <span className="d-block">Diagnóstico</span>
                                    <ul>
                                    {
                                        item.diagnosticos.map((diag, ind)=>(
                                            <li key={ind}>{`${diag.disease?.code4digits} - ${diag.disease?.description}`}</li>
                                        ))
                                    }
                                    </ul>
                                    
                                </li>
                            ))
                        }
                    </ul>
                    <div className="text-right">
                        <Button variant="primary" onClick={handleCloseModal}>Aceptar</Button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )

}

export default withTranslation()(DoctorIncapacidadColombia)